import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0.2, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: [0.2, 0.8, 0.2, 1] }}
    >
      {children}
    </M>
  );
};

export const ImageReveal = ({ children, className = "", delay = 0 }) => (
  <motion.div
    className={className}
    initial={{ scale: 1.12 }}
    whileInView={{ scale: 1 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 1.6, delay, ease: [0.2, 0.8, 0.2, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, children, center = false, className = "mb-12 lg:mb-16" }) => (
  <Reveal className={`${center ? "text-center mx-auto" : ""} max-w-3xl ${className}`}>
    {eyebrow && <div className="eyebrow mb-5">{eyebrow}</div>}
    <h2 className="h-display chrome text-3xl sm:text-4xl lg:text-5xl">{title}</h2>
    {children && <p className={`mt-5 text-slate-300 text-base md:text-lg leading-relaxed ${center ? "mx-auto" : ""} max-w-2xl`}>{children}</p>}
  </Reveal>
);
